define('views/blocks/CartVoucherPriceView',['jquery',
        'underscore',
        'backbone',
        'app',
        'SubView',
        'router',
        'template!blocks/cart/voucherPrice','InternalLinkView'
       ],
    function ($,
              _,
              Backbone,
              app,
              SubView,
              router,
              voucherTemplate, InternalLinkView
              ) {

        return Backbone.View.extend(SubView).extend({

            initialize: function () {

                var view = this,
                    cart = app.getCart();
                view.subviews = [];
                view.listenTo(cart, 'change:total_discount', view.render   );
                view.listenTo(cart, 'change:discounts', view.render   );
                view.render();
            },

            render: function () {
                var view = this,
                    cart = app.getCart(),
                    label = app.t('Réduction code','Cart')+' '+cart.getVoucher().map(function(d){
                        return '<strong>'+d.name+'</strong>'
                    }).join(', '),
                    t = voucherTemplate({
                        cart: cart,
                        label: label
                    });

                view.$el.html(t);
                //
                // chaque ligne produit a une View
                //

                InternalLinkView.initializeLinksOfView(view);
                view.delegateEvents();
            },
        });
    });
